"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityGrid = exports.EntityGridDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var grid_1 = require("../elements/grid");
var use_lang_1 = require("../../hooks/use-lang");
var current_path_name_1 = require("../../utils/current-path-name");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var entity_update_button_1 = require("./entity-update-button");
var entity_card_1 = require("./entity-card");
exports.EntityGridDefaultProps = {
  items: []
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({});
var EntityUpdateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  EntityUpdateButton: (0, styled_components_1.default)(entity_update_button_1.EntityUpdateButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), EntityUpdateButtonStyles)
};
var EntityGrid = function (props) {
  var className = props.className,
    items = props.items,
    entityTypeName = props.entityTypeName,
    maxColumns = props.maxColumns;
  if (!entityTypeName) {
    throw new Error("Error: Entity Grid cannot be rendered. Missing entity type name");
  }
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var card = definition.card,
    routes = definition.routes;
  var listConfig = definition.list;
  var grid = listConfig.grid;
  var divider = grid.divider,
    spacing = grid.spacing,
    autoLink = grid.autoLink;
  var t = (0, use_lang_1.useLang)();
  var columns = props.columns || grid.columns;
  var components = definition.components,
    pluralSlug = definition.pluralSlug;
  var Card = components.card || entity_card_1.EntityCard;
  var from = (0, current_path_name_1.currentPathName)();
  var gridItems = React.useMemo(function () {
    return items.map(function (entity, index) {
      return React.createElement(Card, {
        entityTypeName: entityTypeName,
        entity: entity,
        number: index + 1,
        status: entity.isDraft && 'Draft',
        path: autoLink && definition && definition.to(entity.slug),
        border: columns !== 1 && (index + 1) % 3 !== 0 ? divider : 'none'
      });
    });
  }, [items]);
  return React.createElement(My.Grid, {
    maxColumns: maxColumns,
    className: className,
    columns: columns,
    spacing: spacing,
    itemKeys: items.map(function (item) {
      return item.id;
    }),
    items: gridItems
  });
};
exports.EntityGrid = EntityGrid;
exports.EntityGrid.defaultProps = exports.EntityGridDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;